import styled from 'styled-components';

export const LoginTitleLeft = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;
export const Loginform = styled.form`
  padding: ${({ theme }) => theme.spacing.x10};
  overflow: auto;
`;
export const LoginLoginBox = styled.div`
  height: 100%;
`;
export const LoginForget = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.secondary};
`;
// export const LoginButton = styled.div`
//   margin: auto auto 10px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
// `;
export const Newuser = styled.a`
  color: #1f2c51;
  margin-top: 1rem;
  text-decoration: underline;
`;
export const LoginButton = styled.div`
  margin: auto ${({ theme }) => theme.spacing.x8} 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const sendtosignupPage = styled.a`
  margin-top: ${({ theme }) => theme.spacing.x2};
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.secondary};
`;
